import { render, staticRenderFns } from "./usageDetails.vue?vue&type=template&id=df0081c2&scoped=true"
import script from "./usageDetails.vue?vue&type=script&lang=js"
export * from "./usageDetails.vue?vue&type=script&lang=js"
import style0 from "./usageDetails.vue?vue&type=style&index=0&id=df0081c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0081c2",
  null
  
)

export default component.exports